import { MotifBreadcrumb, MotifBreadcrumbItem } from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import { AppNavItems } from "../../components/myRoutes/AppNavItems";
import { useLocation } from "react-router-dom";
import "./Breadcrumb.scss";
import DOMPurify from 'dompurify';

export const AppBreadcrumbs = () => {
  const [pages, setPages] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const routes = [ {
      id: 0,
      title: 'Home',
      path: '/',
    }];
    const paths = location.pathname.toLowerCase().split("/").splice(1);
    AppNavItems.forEach((item) => {
      paths.forEach((path) => {
        if (item.title.toLowerCase().includes(path)) {
          routes.push(item);
        }
      });
    });
    setPages(routes);
  }, [location.pathname]);
  // If only 'Home' would be shown, suppress breadcrumb entirely 
  if (pages.length <= 1) return null;

  return (
    <div className="breadcrumb-wrap">
      <MotifBreadcrumb>
        {pages.map((item, index) => {
          const isLast = index === pages.length - 1;
          if (isLast) {
            return (
              <MotifBreadcrumbItem key={`${index}-${item.title}`}>{item.title}</MotifBreadcrumbItem>
            );
          }
          return (
            <MotifBreadcrumbItem key={`${index}-${item.title}`}>
              <a
                href={DOMPurify.sanitize(`${window.location.origin}${item.path}`)}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, '', item.path);
                  window.dispatchEvent(new Event('popstate'));
                }}
              >
                {item.title}
              </a>
            </MotifBreadcrumbItem>
          );
        })}
      </MotifBreadcrumb>
    </div>
  );
};